import React, { useEffect } from 'react';
import './ConfirmDialog.css';

export default function ConfirmDialog({ open, title, message, confirmText, cancelText, onConfirm, onCancel, busy }) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onCancel?.();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="shared-confirmBackdrop" role="dialog" aria-modal="true" aria-label={title || 'Confirm'}>
      <div className="shared-confirm">
        <div className="shared-confirmHeader">{title || 'Confirm'}</div>
        <div className="shared-confirmBody">{message}</div>
        <div className="shared-confirmFooter">
          <button className="svc-btn" type="button" onClick={onCancel} disabled={busy}>
            {cancelText || 'Cancel'}
          </button>
          <button className="svc-btn svc-btn--primary" type="button" onClick={onConfirm} disabled={busy}>
            {confirmText || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
